<!--
 * @Author: your name
 * @Date: 2020-12-27 22:22:47
 * @LastEditTime: 2020-12-28 14:24:17
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /yunlizhi/货主端1.0/src/pages/orderManage/orderManageDetail/BaseInfo.vue
-->
<template>
  <div class="BaseInfo-root">
    <!-- <order-status :order-detail="orderDetail" class="info-panel-first"></order-status> -->
    <order-summary :order-detail="orderDetail" :sensitive-fields="sensitiveFields" class="info-panel"></order-summary>
    <order-address v-if="carShow" :order-detail="orderDetail" class="info-panel"
      :negotiation-type="orderDetail.negotiationType" @cancel="getOrderDetail" />
    <order-amount v-if="sensitiveFields.includes('order_amount')" :order-detail="orderDetail" class="info-panel" @tofetch="getOrderDetail"></order-amount>
  </div>
</template>

<script>
import { ruleCropSensitive } from '@/api/orderRules'
import { featchOrderDetailUnify } from '../api.js'
// import OrderStatus from './components/OrderStatus.vue'
import OrderSummary from './components/OrderSummary.vue'
import OrderAddress from './components/OrderAddress.vue'
import OrderAmount from './components/OrderAmount.vue'

export default {
  name: 'BaseInfo',
  components: {
    // OrderStatus,
    OrderSummary,
    OrderAddress,
    OrderAmount
  },
  data () {
    return {
      odrNo: this.$route.query.odrNo,
      orderDetail: {},
      carShow: false,
      sensitiveFields: []
    }
  },
  computed: {
  },
  created () {
    this.getOrderDetail()
  },
  mounted () { },
  methods: {
    async getSensitiveRule(){
      const customerReqs = [
        {
          customerCode: this.orderDetail.tenantId,
          carrierTenantId: this.orderDetail.carrierTenantId,
        }
      ]
      const res = await ruleCropSensitive({customerReqs})
      this.sensitiveFields = res.result?.orderSensitiveFields || []
    },
    async getOrderDetail () {
      if(this.odrNo) {
        const orderDetail = await featchOrderDetailUnify({
          unifyOdrNo: this.odrNo
        })
        this.orderDetail = orderDetail
        this.getSensitiveRule()
        this.$emit('changeDetail', orderDetail)
        this.carShow = true
      }
    }
  },
}
</script>

<style lang="less" scoped>
.info-panel {
  margin-top: 16px;
}

.info-panel-first {
  background-color: #fff;
}

.BaseInfo-root {
  overflow: hidden;
}
</style>
